import { useState } from "react";
import { useAddClientSetAccessMutation, useFetchClientSetAccessQuery, usePatchClientSetAccessMutation } from "../../../services/campaignmanagement";
import { useClientSetContext } from "./ClientSetContext";
import toast from "react-hot-toast";

const useClientSetPermissions = () => {
    const {
        selectedSetId
    } = useClientSetContext()

    const { data: accessList, isFetching } = useFetchClientSetAccessQuery({ clientSetId: selectedSetId }, { skip: selectedSetId == null });

    const [addTrigger] = useAddClientSetAccessMutation();
    const [showUserSelect, setShowUserSelect] = useState(false);
    const [addUserId, setAddUserId] = useState(null);

    const addUser = () => {
        return toast.promise(
            new Promise((resolve, reject) => {
                setShowUserSelect(false);

                if (addUserId == null || accessList.some((user) => user.userId === addUserId)) {
                    return reject("User Already Exists");
                }

                return addTrigger({
                    clientSetId: selectedSetId,
                    userId: addUserId,
                    canRead: true,
                    canWrite: false
                }).unwrap()
                    .then(r => resolve(r))
                    .catch(e => reject(e));
            }),
            {
                loading: "Adding User...",
                success: "User Added",
                error: (err) => `Error Adding User: ${err.data ?? err}`
            }
        );
    }

    const [patchTrigger] = usePatchClientSetAccessMutation();

    const updateUser = ({ userId, canRead, canWrite }) => {
        return toast.promise(
            patchTrigger({
                clientSetId: selectedSetId,
                userId,
                canRead,
                canWrite
            }).unwrap(),
            {
                loading: "Updating User...",
                success: "User Updated",
                error: (err) => `Error Updating User: ${err.message}`
            }
        )
    }

    return {
        accessList,
        isFetching,
        showUserSelect,
        setShowUserSelect,
        addUserId,
        setAddUserId,
        addUser,
        updateUser
    }
}

export default useClientSetPermissions;